// extracted by mini-css-extract-plugin
export default {"wholeTableReservationWrapper":"WxM8C"};